var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 17,
    viewBox: "0 0 101 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.3358 12.5317C80.7457 12.5317 67.2507 12.621 53.7494 13.0849C50.6862 13.1901 47.6265 13.2932 44.5692 13.3963C37.1151 13.6475 29.6745 13.8982 22.2293 14.1784C21.2931 14.2136 20.4179 14.2354 19.5895 14.2561C17.1444 14.3171 15.1067 14.3679 13.1118 14.7232C12.5239 14.8279 11.9007 15.0094 10.8824 15.3174C10.8503 15.3271 10.8177 15.337 10.7846 15.347C9.88246 15.62 8.62667 16.0001 7.2723 16.2404C4.00955 16.8192 0.895292 14.6435 0.316415 11.3808C-0.26246 8.11803 1.91325 5.00377 5.17601 4.42489C5.76802 4.31986 6.39464 4.1378 7.40897 3.83106C7.44443 3.82034 7.48049 3.80942 7.51714 3.79833C8.4148 3.52659 9.66441 3.14831 11.0079 2.90905C13.9953 2.37705 17.2993 2.29973 19.9079 2.23868C20.5838 2.22286 21.2131 2.20814 21.778 2.18688C29.2481 1.90574 36.7259 1.65376 44.1898 1.40224C47.2418 1.29939 50.2915 1.19662 53.3373 1.09197C67.0475 0.620918 80.7061 0.531738 94.3358 0.531738C97.6495 0.531738 100.336 3.21803 100.336 6.53174C100.336 9.84545 97.6495 12.5317 94.3358 12.5317Z",
    fill: "#1FB32E65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusbg);
export default __webpack_public_path__ + "static/media/statusbg.f0637d06c16e62c8cee4e8ecc7916c31.svg";
export { ForwardRef as ReactComponent };